import ValueObject from './ValueObject';

export default class DunsNumber extends ValueObject {
  equals(other) {
    if (!(other instanceof DunsNumber)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new DunsNumber(json);
  }
}
